<template>
    <div class="p-4 email">
        <K2Heading type="h3" class="mb-4" bold="true">
            Email Editor
        </K2Heading>
        <!--@handleEdit="handleEdit()"-->
        <EmailHeader @handleEmpty="handleEmpty()" @handlePost="handlePost()"
                     :title="this.title"/>
        <div class="box grey">
            <EmailEditor ref="emailEditor" v-on:load="editorLoaded"/>
        </div>
        <K2Modal title="Edit Title" :dialog="modal==='title'" @handleClose="handleClose" @onConfirm="handleConfirm">
            <K2Input label="Title" v-model="this.title" name="title" @onchange="handleInputChange"></K2Input>
        </K2Modal>
        <K2Modal title="Email Preview & Post" :dialog="modal==='post'" @handleClose="handleClose" :overlayClose="false"
                 @onConfirm="handleNext()" ref="modal_PostComponent">
            <EmailPost @onchange="handleInputChange" @onchange_emailGroups="handleEmailGroups"
                       @handleReceiverType="handleReceiverType"
                       @result="displayResult"
                       :paramCurrentPage="currentPage"
                       :paramInnerHTML="str_InnerHTML"
            />
        </K2Modal>
        <!-- <K2Modal :fullscreen="true" :dialog="modal==='student'" @handleClose="handleClose" :overlayClose="false"
                 hideHeader="true" confirm-text="Send Email"
                 @onConfirm="handleConfirm" :show-close="false">
          <EmailByStudent @handleBack="handleBack()"/>
        </K2Modal> -->
        <!-- <K2Modal :fullscreen="true" :dialog="modal==='academic'" @handleClose="handleClose" :overlayClose="false"
                 hideHeader="true" confirm-text="Send Email"
                 @onConfirm="handleConfirm" :show-close="false">
          <EmailByAcademic @handleBack="handleBack()"/>
        </K2Modal> -->
    </div>
</template>

<script>
  "use strict";
  import Vue from "vue";
  import DataSource from "../../data/datasource";
  import K2Heading from "../../uiComponents/k2Heading/k2Heading";
  import EmailHeader from "./component/emailHeader";
  import K2Modal from "../../uiComponents/k2Modal/k2Modal";
  import K2Input from "../../uiComponents/k2Input/k2Input";
  import EmailPost from "./component/emailPost";
  //import EmailByStudent from "./component/emailByStudent";
  //import EmailByAcademic from "./component/emailByAcademic";
  import assets from "../../assets/assets";
  import uiVariable from "../../config/uiVariable";
  import { lang } from "../../locale/index";
  import "./email.scss";
  import sample_Empty from "../../data/sample_Empty.json";
  import sample from "../../data/sample.json";
  //import emailComponent from '../../components/Email/Post_Email_Component';
  import { EmailEditor } from "vue-email-editor";

  //todo:after update vue-email-editor module need add
  //todo: registerCallback(callback) {
  //todo:   this.editor.registerCallback(callback);
  //todo: },

  export default {
    name: "EmailCampaign",
    components: {
      //EmailByAcademic,
      //EmailByStudent,
      EmailPost,
      K2Input,
      K2Modal,
      EmailHeader,
      K2Heading
    },
    props: {},
    data() {
      return {
        currentPage: "",
        emailPostComponentTitle: "",
        str_InnerHTML: "",
        uiVariable: uiVariable,
        assets: assets,
        title: "New Email Editor",
        modal: null,
        emailSubject: "",
        emailFrom: "",
        emailToBcc: "",
        emailGroups: [],
        emailStudentListTags: []
      };
    },
    mounted() {

    },
    methods: {
      lang,//To Import Language Translate
      editorLoaded() {
        this.$refs.emailEditor.editor.loadDesign(sample); //sample
        this.$refs.emailEditor.editor.registerCallback("image", async function(file, done) {
          // Your code
          try {
            const response = await DataSource.shared.getEditorUploadURL(file.attachments[0]);
            if (response) {
              if (response.file0) {
                done({ url: response.file0 });
              } else {
                this.$notify({
                  title: lang("Error"),
                  message: lang(`Couldn't upload file: ${file.name}.`),
                  type: "error"
                });
              }
            }
          } catch (e) {
            console.log("getEditorUploadURL err", e);
          }
        });
      },
      saveDesign() {
        this.$refs.emailEditor.editor.saveDesign(
          (design) => {
            console.log("saveDesign", design);
          }
        );
      },
      exportHtml() {
        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            // console.log('exportHtml:', data.html);
          }
        );
      },
      emptyTemplate() {
        this.$refs.emailEditor.editor.loadDesign(sample_Empty);
      },
      showEmailModal() {
        this.emailPostComponentTitle = "Email Preview & Post";

        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            this.str_InnerHTML = data.html;
            // console.log('exportHtml:', this.str_InnerHTML);
            this.showComponentModal();
          });
      },

      displayResult(value) {
        switch (value) {
          case "TRUE":
            this.$notify({
              title: lang("Success"),
              message: lang("Successfully Posted"),
              type: "success"
            });
            // this.str_Result = "Successfully posted!";
            break;
          case "FALSE":
            this.$notify.error({
              title: lang("Error"),
              message: lang("Whoops. Something went wrong. Please check your fields and try again.")
            });
            // this.str_Result = "Whoops. Something went wrong. Please check your fields and try again.";
            break;
        }

        this.rerendarComponent();
        this.hideComponentModal();
      },

      /*#region Show different modal Functions*/
      showComponentModal() {
        //this.obj_ComponentProperties = {images: this.arrobj_SelectedItem};
        // this.$refs.modal_PostComponent.show();
      },

      hideComponentModal() {
        this.$refs.modal_PostComponent.hide();
      },
      /*#endregion*/

      rerendarComponent() {
        this.$emit("rerendarCurrentComponent", true);
      },
      handleEdit() {
        this.modal = "title";
      },
      handleConfirm() {
        this.handleClose();
      },
      handleClose() {
        this.modal = null;
      },
      handleInputChange(value, name) { //to return all property value & from Child
        this[name] = value;
        //alert("handleInputChange: " + name + "||" + value)
      },
      handleEmpty() {
        this.$refs.emailEditor.editor.loadDesign(sample_Empty);
      },
      handlePost() {
        this.emailPostComponentTitle = "Email Preview & Post";

        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            this.str_InnerHTML = data.html;
            // console.log('exportHtml:', this.str_InnerHTML);
            this.showComponentModal();
          });
        this.modal = "post";
      },
      handleNext() {
        if (this.handleValidation() === true) {
          this.onEmailSend();
          //this.modal = "student" //Next to emailByStudent Component
        }
      },
      handleBack() {
        this.modal = "post";
      },
      setModal(value) {
        this.modal = value;
      },
      handleReceiverType(type) {
        this.modalType = type;
      },
      handleEmailGroups(value) {
        this.emailGroups = value;
      },
      handleValidation() {
        //alert("emailStudentListTags: " + this.emailStudentListTags.length);
        //alert(JSON.stringify(this.emailStudentListTags))

        //Validation email From,
        if (this.emailFrom.trim() === "") {
          this.$notify.error({
            title: lang("Error"),
            message: lang("Please Insert email From")
          });
          return;
        } else if (!this.emailFrom.trim().includes("@etonhouse.com.sg") && !this.emailFrom.trim().includes("@etonhouse.edu.sg") && !this.emailFrom.trim().includes("@middleton.edu.sg")) {
          this.$notify.error({
            title: lang("Error"),
            message: lang("email From: domain format wrong")
          });
          return;
        } else {
          //console.log(JSON.stringify(this.emailFrom)) //Print
        }

        //Validation Student List Count
        if (this.emailStudentListTags.length <= 0 && this.emailToBcc.trim() === "") {
          this.$notify.error({
            title: lang("Error"),
            message: lang("Please Select Student")
          });
          return;
        } else {
          //console.log(JSON.stringify(this.emailStudentListTags)) //Print
        }

        //Validation Email Subject
        if (this.emailSubject.trim() === "") {
          this.$notify.error({
            title: lang("Error"),
            message: lang("Please Insert Email Subject")
          });
          return false;
        } else {
          //console.log(JSON.stringify(this.emailSubject)) //Print
        }

        //Validation Email Group Type (Father Mother)
        if (this.emailGroups.length <= 0 && this.emailToBcc.trim() === "") {
          this.$notify.error({
            title: lang("Error"),
            message: lang("Please Select Email Group")
          });
          return;
        } else {
          //console.log(JSON.stringify(this.emailGroups)) //Print
        }

        return true;
      },
      async onEmailSend() {
        this.$vs.loading();

        //const resp = DataSource.shared.HelloWorld();
        const response = await DataSource.shared.SendEmailBcc(
          this.emailSubject,

        encodeURIComponent(this.str_InnerHTML)
          , JSON.stringify(this.emailStudentListTags)
          , JSON.stringify(this.emailGroups)
          , this.emailFrom
          , this.emailToBcc
        );

        if (response) {
          this.$vs.loading.close();

          if (response.code === "88") {
            window.location.replace("/");
          } else if (response.code === "99") {
            //console.log('send email error!');
            this.$notify.error({
              title: lang("Error"),
              message: lang("send email error!")
            });
            return;
          } else if (response.code === "Success") {
            //console.log('send email Successfully!');
            this.$notify({
              title: lang("Success"),
              message: lang("send email Successfully!")
            });
            //this.$emit("result", "CANCEL");
            this.handleClose();
            return;
          } else {
            //this.openClassCoordinator();
            //this.$refs.updateCoordinatorModel.hide();
          }
        }
        //alert("onEmailSend: " + response.code);
        this.$vs.loading.close();

      }
    }
  }
  ;
</script>

<style>
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
    }

    #app, #example {
        height: 100%;
    }

    #example .container {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
    }

    #bar {
        flex: 1;
        background-color: #40B883;
        color: #FFF;
        padding: 10px;
        display: flex;
        max-height: 50px;
    }

    #bar h1 {
        flex: 1;
        padding: 5px;
        font-size: 16px;
        text-align: left;
    }

    #bar button {
        flex: 1;
        padding: 5px;
        margin-left: 5px;
        font-size: 14px;
        font-weight: bold;
        background-color: #000;
        color: #FFF;
        border: 0px;
        max-width: 100px;
        cursor: pointer;
    }
</style>
